'use strict';

angular.module('lmsApp')
    .factory('Territory', function ($resource) {
        return $resource('api/territories/:id', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method:'PUT'
            }
        });
    });
